import {
    USER_TYPE, ERROR_MESSAGES,
    ALERT_SEVERITY, CONFIG_OTP_RESEND_ATTEMPTS
} from '../constants';
import { setGlobalMessage, setLoading, clearGloablMessage } from './app'
import { Catch } from './api_exception';

const BASE_PATH = 'REGISTER';

export const SET_REGISTER_DATA = `${BASE_PATH}/SET_REGISTER_DATA`;
export const CLEAR_REGISTER_DATA = `${BASE_PATH}/CLEAR_REGISTER_DATA`;


export const setRegisterData = data => ({
    type: SET_REGISTER_DATA,
    data
});

export const clearRegisterData = () => ({
    type: CLEAR_REGISTER_DATA,
});


export const registerUser = () =>
    (dispatch, getState, client) => {

        dispatch(clearGloablMessage());
        dispatch(setLoading(true));

        let appState = getState();
        let state = appState.REGISTER_DATA;

        client.post('/auth/verify', {
            firstName: state.firstName,
            lastName: state.lastName,
            email: state.email,
            mobileNumber: state.mobileNumber,
            password: state.password,
            userType: state.type,
            token: state.otpToken
        }).then(res => res.data).then(result => {
        
            if (result.isSuccess) {

                // dispatch(setGlobalMessage(result.message, ALERT_SEVERITY.SUCCESS));
                // dispatch(setRegisterData([
                //     { key: "openOTPModal", value: true },
                //     { key: "otpToken", value: result.data.opt_token }
                // ]));


                client.post('/auth/processOtp', {
                    emailOtp: "123456",
                    mobileOtp: "123456",
                    requestType: "verify",
                    otpToken: result.data.opt_token
                }).then(res => res.data).then(result1 => {

                     dispatch(setLoading(false));

                    if (result1.isSuccess) {
                        dispatch(clearRegisterData());
                        dispatch(setGlobalMessage(result1.successMessage, ALERT_SEVERITY.SUCCESS));
                    } else {
                        if (result1.fieldErrors) {
                            dispatch(setRegisterData(result1.fieldErrors));
                        } else {
                            dispatch(setGlobalMessage(result1.errorMessage ?
                                result1.errorMessage :
                                ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                        }
                    }
                }).catch(error => {
                    Catch(error, dispatch);
                });

            } else {
                 dispatch(setLoading(false));

                if (result.fieldErrors && Array.isArray(result.fieldErrors)) {
                    dispatch(setRegisterData(result.fieldErrors));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ? result.errorMessage
                        : ERROR_MESSAGES.SERVER_FAULT,
                        ALERT_SEVERITY.ERROR));
                }
            }
        }).catch(error => {
            Catch(error, dispatch);
        });
    }

export const verifyOtp = () =>
    (dispatch, getState, client) => {

        dispatch(setRegisterData([
            { key: "emailOtpProcessing", value: true },
            { key: "emailOtpError", value: '' },
            { key: "mobileOtpProcessing", value: true },
            { key: "mobileOtpError", value: '' }
        ]));

        let state = getState().REGISTER_DATA;
        client.post('/auth/processOtp', {
            emailOtp: state.emailOTP,
            mobileOtp: state.mobileOTP,
            requestType: "verify",
            otpToken: state.otpToken
        }).then(res => res.data).then(result => {

            dispatch(setRegisterData([
                { key: "emailOtpProcessing", value: false },
                { key: "mobileOtpProcessing", value: false },
            ]));

            if (result.isSuccess) {
                dispatch(clearRegisterData());
                dispatch(setGlobalMessage(result.successMessage, ALERT_SEVERITY.SUCCESS));
            } else {
                if (result.fieldErrors) {
                    dispatch(setRegisterData(result.fieldErrors));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }
        }).catch(error => {
            dispatch(setRegisterData([
                {
                    key: "emailOtpProcessing",
                    value: false
                },
                {
                    key: "mobileOtpProcessing",
                    value: false
                },
            ]));
            Catch(error, dispatch);
        });
    }

export const resendOtp = (isEmail) =>
    (dispatch, getState, client) => {

        dispatch(setRegisterData([
            {
                key: isEmail ? "emailOtpProcessing" :
                    "mobileOtpProcessing",
                value: true
            },
            {
                key: isEmail ? "emailOtpError" :
                    "mobileOtpError",
                value: ''
            },
        ]));

        let appState = getState();
        let state = appState.REGISTER_DATA;

        client.post('/auth/processOtp', {
            type: isEmail ? "email" : "mobile",
            otp: isEmail ? state.emailOTP : state.mobileOTP,
            requestType: "resend",
            otpToken: state.otpToken
        }).then(res => res.data).then(result => {

            let isEmail = result.type === "email" ? true : false;
            dispatch(setRegisterData([
                {
                    key: isEmail ? "emailOtpProcessing" :
                        "mobileOtpProcessing",
                    value: false
                },
            ]));

            if (result.isSuccess) {
                dispatch(setRegisterData([
                    {
                        key: isEmail ? "emailOtpResent" : "mobileOtpResent",
                        value: true
                    },
                    {
                        key: isEmail ? "emailOTPResendAttemps" : "mobileOTPResendAttemps",
                        value: result.attempts ? result.attempts : ''
                    },
                ]));

            } else {
                let errorMessage = result.errorMessage;

                if (result.fieldErrors) {
                    result.fieldErrors.forEach(error => {
                        if (error.key.toLowerCase() == "otperror") {
                            errorMessage = error.value;
                        }
                    });
                }

                dispatch(setRegisterData([
                    {
                        key: isEmail ? "emailOtpError" : "mobileOtpError",
                        value: errorMessage
                    },
                ]));
            }
        }).catch(error => {
            dispatch(setRegisterData([
                {
                    key: isEmail ? "emailOtpProcessing" :
                        "mobileOtpProcessing",
                    value: false
                },
            ]));
            Catch(error, dispatch);
        });
    }


const initialState = {
    errorMessage: '',
    type: "",

    firstName: '',
    firstNameError: '',

    lastName: '',
    lastNameError: '',

    email: '',
    emailError: '',

    mobileNumber: '',
    mobileNumberError: '',

    password: '',
    passwordError: '',

    isSaving: false,

    successMessage: '',
    openOTPModal: false,

    otpToken: '',
    emailOTPResendAttemps: CONFIG_OTP_RESEND_ATTEMPTS,
    mobileOTPResendAttemps: CONFIG_OTP_RESEND_ATTEMPTS,

    emailOTP: '',
    mobileOTP: '',
    emailOtpProcessing: false,
    mobileOtpProcessing: false,

    emailOtpVerified: false,
    emailOtpResent: false,
    emailOtpError: '',

    mobileOtpVerified: false,
    mobileOtpResent: false,
    mobileOtpError: '',
    openTerms: false,
}


export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_REGISTER_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case CLEAR_REGISTER_DATA:
            return { ...initialState };
        default:
            break;
    }

    return state;
}